export interface PhotoTransform {
  scale: number;
  x: number;
  y: number;
}
export interface PhotoFrame {
  width: number;
  height: number;
  imageWidth: number;
  imageHeight: number;
}
export const FIT_PHOTO: PhotoTransform = { scale: 1, x: 0, y: 0 };

export function constrainPhoto(value: PhotoTransform, frame: PhotoFrame): PhotoTransform {
  const scale = Math.max(1, Math.min(8, value.scale));
  const fit = Math.min(frame.width / frame.imageWidth, frame.height / frame.imageHeight);
  const x = Math.max(0, (frame.imageWidth * fit * scale - frame.width) / 2);
  const y = Math.max(0, (frame.imageHeight * fit * scale - frame.height) / 2);
  return { scale, x: Math.max(-x, Math.min(x, value.x)), y: Math.max(-y, Math.min(y, value.y)) };
}

/// Mantém sob os dedos o mesmo ponto da imagem, inclusive quando o centro da pinça se move.
export function zoomPhoto(
  value: PhotoTransform,
  scale: number,
  point: { x: number; y: number },
  frame: PhotoFrame,
  move = { x: 0, y: 0 },
): PhotoTransform {
  const next = Math.max(1, Math.min(8, scale));
  const factor = next / value.scale;
  return constrainPhoto(
    {
      scale: next,
      x: point.x - (point.x - value.x) * factor + move.x,
      y: point.y - (point.y - value.y) * factor + move.y,
    },
    frame,
  );
}
